import { createAsyncTypes } from 'utils/ActionCreator'

export const INTELLIGENCE_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'INTELLIGENCE_SETTINGS_REQUEST',
  'Settings/Intelligence/ShowIntelligenceSettings'
)
export const UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'UPDATE_INTELLIGENCE_SETTINGS_REQUEST',
  'Settings/Intelligence/ShowIntelligenceSettings'
)

export const TOGGLE_SPAM_FF_REQUEST_ASYNC = createAsyncTypes(
  'TOGGLE_SPAM_FF_REQUEST',
  'Settings/Intelligence/ShowIntelligenceSettings'
)
